export const DA: Record<string, string> = {
  "Recommended for you": "Anbefalet til dig",
  "Resource added to favorite": "Ressource tilføjet til favoritter",
  "Failed to add resource to favorite": "Kunne ikke tilføje ressource til favoritter",
  "Resource removed from favorite": "Ressource fjernet fra favoritter",
  "Failed to remove resource from favorite": "Kunne ikke fjerne ressource fra favoritter",
  "Calendar": "Kalender",
  "View Detail": "Se detaljer",
  "Add to favorites": "Tilføj til favoritter",
  "Remove from favorites": "Fjern fra favoritter",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Beskrivelse: VIP-mødelokale med en fantastisk udsigt og behagelige stole.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Der er ingen tilgængelige ressourcer på det valgte tidspunkt på din placering eller i dine favoritter.",
  "You have these options:": "Du har disse muligheder:",
  "Change the meeting time.": "Skift mødetidspunktet.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Brug knappen <1>Find ledig tid</1> til at vælge et nyt tidspunkt.",
  "Open the search to find other resources.": "Åbn søgningen for at finde andre ressourcer.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "Ressourcetype <1>'{{resourceType}}'</1> findes ikke på din standardplacering",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "Ressourcetype <1>'{{resourceType}}'</1> kan findes på en anden placering.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Klik her</1> for at tilføje ressourcetype til dine standardplaceringindstillinger.",
  
  // ResourceCard
  "New Order": "Ny bestilling",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Ved booking af en Pooled Resource kan kun denne ressource type og kun én ressource bookes.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Du kan ikke vælge både en underressource og dens virtuelle ressource på samme tid.",
  // Settings
  "Note:": "Bemærk:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "En assisterende arrangør kan modtage de samme e-mails fra Resource Central som arrangøren og kan håndtere bestillinger på vegne af arrangøren.",
  "Setting updated successfully": "Indstilling opdateret",
  "Setting updated failed": "Opdatering af indstilling mislykkedes",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 plads",
  "Opening hours:": "Åbningstider:",
  "Buffer time {{minutes}} mins between reservations": "Buffertid {{minutes}} min mellem reservationer",
  "Initial payment {{value}} pr.minute": "Første betaling {{value}} pr. minut",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "I alt {{total}} deltagere",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} af {{total}} interne kan deltage.",
  "{{external}} external is unknown.": "{{external}} eksterne er ukendte.",
  "Find available time": "Find ledig tid",
  "Attendees": "Deltagere",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Klik på Yderligere oplysninger for at besøge vores supportside",
  "Further information": "Yderligere oplysninger",
  
  // LocationSetting
  "Location changed": "Placering ændret",
  "Location change failed": "Ændring af placering mislykkedes",
  "Please select at least one location": "Vælg venligst mindst én placering",
  "Resource types": "Ressourcetyper",
  "Location": "Placering",
  "Where": "Hvor",
  
  // ModalShowAttendees
  "Total": "I alt",
  "Available": "Tilgængelig",
  "Busy": "Optaget",
  "External": "Ekstern",
  "Internal": "Intern",
  
  // ResourceSearch
  "Search by resource name": "Søg efter ressourcenavn",
  "Category": "Kategori",
  "Filter by Location": "Filtrer efter placering",
  "Filter by Category": "Filtrer efter kategori",
  "Capacity": "Kapacitet",
  "Filter by Capacity": "Filtrer efter kapacitet",
  "All": "Alle",
  "Filter by availability": "Filtrer efter tilgængelighed",
  "Sort By": "Sorter efter",
  "Loading...": "Indlæser...",
  
  // SelectedResources
  "Meeting Type": "Mødetype",
  "Meeting Label": "Mødemærke",
  
  // Alert (accessibility text)
  "Check icon": "Flueben-ikon",
  "Close": "Luk",
  
  // AppConstants - searchTab
  "Resource": "Ressource",
  "Person": "Person",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Hvor foregår dine møder normalt?",
  "To improve our recommendations for you we would like you to enter your normal location": "For at forbedre vores anbefalinger til dig vil vi gerne have, at du indtaster din normale placering",
  "What do you use most?": "Hvad bruger du mest?",
  "To enable quicker and better search please chose you prefered resource type": "For at muliggøre hurtigere og bedre søgning skal du vælge din foretrukne ressourcetype",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Klik på ressource for at vælge",
  "Selected Resources": "Valgte ressourcer",
  "Setting": "Indstilling",
  "Search": "Søg",
  "Find Colleague": "Find kollega",
  "Quick button setting": "Hurtig knap-indstilling",
  "Favorite": "Favorit",
  "Most Used": "Mest brugte",
  "Colleagues": "Kolleger",
  "Resources": "Ressourcer",
  
  // AppConstants - tooltipText
  "Back": "Tilbage",
  "Floor Plan": "Plantegning",
  "Expand": "Udvid",
  "Selected resources": "Valgte ressourcer",
  "View details": "Se detaljer",
  "Remove from My Favorites": "Fjern fra mine favoritter",
  "Add to My Favorites": "Tilføj til mine favoritter",
  "Remove": "Fjern",
  "Favorite - Most Used": "Favorit - Mest brugte",
  "Conflict": "Konflikt",
  "Approved": "Godkendt",
  "Recommendeded for you": "Anbefalet til dig",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Kun primær arrangør",
  "Only assistant organizer": "Kun assisterende arrangør",
  "Primary AND assistant organizer": "Primær OG assisterende arrangør",
  
  // FindColleague
  "Enter colleague name": "Indtast kolleganavn",
  "Recent work items": "Seneste arbejdselementer",
  "No data available": "Ingen data tilgængelige",
  "Floorplan": "Plantegning",
  "List nearby resources": "Liste over ressourcer i nærheden",
  "Find resource nearby": "Find ressource i nærheden",
  "No Resources available": "Ingen ressourcer tilgængelige",
  
  // Start page
  "Next": "Næste",
  "Failed to update default locations": "Kunne ikke opdatere standardplaceringer",
  "Resource Type": "Ressourcetype",
  
  // QuickSetting
  "Quick buttons updated successfully": "Hurtigknapper opdateret",
  "Quick buttons updated failed": "Opdatering af hurtigknapper mislykkedes",
  "Add more": "Tilføj flere",
  "Apply": "Anvend",
  "Delete": "Slet",
  "Name": "Navn",
  "Enter name": "Indtast navn",
  "Tooltip": "Værktøjstip",
  "Enter tooltip": "Indtast værktøjstip",
  "Type": "Type",
  "Select type": "Vælg type",
  "Locations": "Placeringer",
  "Select colleagues": "Vælg kolleger",
  "Select resources": "Vælg ressourcer",
  
  // DefaultResourceSetting
  "Resource type changed": "Ressourcetype ændret",
  "Resource type change failed": "Ændring af ressourcetype mislykkedes",
  "Default Resource Type": "Standard ressourcetype",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Anvendt succesfuldt",
  "Apply Failed": "Anvendelse mislykkedes",
  "Assistant Organizer": "Assisterende arrangør",
  "Enter a part of the name to search for": "Indtast en del af navnet for at søge",
  "Mail Flow": "Mailflow",
  "Select Mail Flow": "Vælg mailflow",
  
  // TileConfigurationSetting
  "Update settings successfully": "Indstillinger opdateret",
  "Update settings failed": "Opdatering af indstillinger mislykkedes",
  "Timeline": "Tidslinje",
  
  // SelectCategoryForm
  "And": "Og",
  "Or": "Eller",
  
  // Other
  "Resource Calendar": "Ressourcekalender",
  
  // SettingLabels
  "Default Location": "Standardplacering",
  "Quick button": "Hurtigknap",
  "Category icons": "Kategoriikoner",
  "Recommendation screen": "Anbefalingsskærm",
  "Capacity filter": "Kapacitetsfilter",
  "AI Assistant": "AI-assistent",
  "Tile configuration": "Flisekonfiguration",
  "Help": "Hjælp",
  "Default Categories": "Standardkategorier",
  
  // MeetingType
  "Your must select a Meeting label": "Du skal vælge et mødemærke",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Valgt ressource: 'AOD_Copanhagen' Konfliktende forekomster",
  "Alternative Resource": "Alternativ ressource",
  "OK": "OK",
  "Cancel": "Annuller",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Din valgte ressource 'AOD_Copenhagen' blev fjernet",
  "You can't book this resource as your request exceeds the available capacity.": "Du kan ikke booke denne ressource, da din anmodning overstiger den tilgængelige kapacitet.",
  
  // ChangeTime
  "Time changed successfully": "Tid ændret succesfuldt",
  "Current Time": "Nuværende tid",
  "Suggested Times": "Foreslåede tidspunkter",
  "Change Time": "Skift tid",
  "people are free": "personer er ledige",
};
